<template>
  <div class="career-counselling-page study-abroad-fair">
    <section class="hero-text-img-section">
      <div class="container-fluid px-0">
        <div class="row justify-content-center px-3 px-lg-5">
          <div class="col-lg-7 pt-5">
            <div>
              <div class="d-block d-md-none">
                <img
                  class="main-logo"
                  src="@/assets/imgs/fair/final global edu logo.jpg"
                  width="150px"
                  style="margin:auto;display:flex"
                />
                <p class="text-center"
                  ><b>Sometimes, one single event could change your life!</b></p
                >
              </div>
              <div
                class="d-flex flex-wrap justify-content-center"
                style="gap:10px"
              >
                <h4 class="main-heading-1-gradient mb-0 custom_font"
                  >Sponsored by</h4
                >
                <div>
                  <img
                    class="main-logo"
                    src="@/assets/imgs/main-logo.svg"
                    width="72px"
                  />
                </div>
              </div>
              <!-- <hr /> -->
              <div data-aos="fade-right">
                <img
                  src="@/assets/imgs/fair/group-merry-students.jpg"
                  class="img-fluid custom_img_design"
                />
              </div>
              <!-- <h3 class="">Master / MBA Programs</h3> -->
              <!-- <h4 class="main-content-1 mt-2">
                A post-grad focused education fair
              </h4> -->
              <!-- <div class="mt-4 font-weight-bold d-flex align-items-center">
                <img
                  src="@/assets/imgs/svgs/sound.svg"
                  alt=""
                  class="img-fluid"
                  width="50px"
                />
                <h4 class="main-content-1 pl-3"
                  >Last Call for 2022 Admissions</h4
                >
              </div> -->
              <div class="event-details">
                <div class="flex flex-wrap">
                  <!-- <img
                    src="@/assets/imgs/svgs/calendar.svg"
                    alt=""
                    class="img-fluid"
                  /> -->
                  <p class="custom_font_title">Date:</p>
                  <p>19th February, 2023</p>
                </div>
                <div class="flex flex-wrap">
                  <!-- <img
                    src="@/assets/imgs/svgs/map.svg"
                    alt=""
                    class="img-fluid"
                  /> -->
                  <p class="custom_font_title">Venue:</p>
                  <p>The Orchid Hotel, Near Mumbai International Airport</p>
                </div>
                <div class="flex flex-wrap">
                  <!-- <img
                    src="@/assets/imgs/svgs/globe.svg"
                    alt=""
                    class="img-fluid svg_custom_width"
                  /> -->
                  <p class="custom_font_title">Website:</p>
                  <p>www.aliff.in</p>
                </div>
                <div class="flex flex-wrap">
                  <!-- <img
                    src="@/assets/imgs/svgs/call.svg"
                    alt=""
                    class="img-fluid svg_custom_width"
                  /> -->
                  <p class="custom_font_title">Contact:</p>
                  <p
                    >Ms. Jenny Dsa, Sr. Manager - Business Operations |
                    jenny@aliff.in +91 96999 90552</p
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-5 pt-2">
            <div
              class="d-flex flex-wrap justify-content-center"
              style="gap:10px"
            >
              <div class="d-none d-md-block">
                <img
                  class="main-logo"
                  src="@/assets/imgs/fair/final global edu logo.jpg"
                  width="150px"
                  style="margin:auto;display:flex"
                />
                <p class="text-center mb-2"
                  ><b>Sometimes, one single event could change your life!</b></p
                >
              </div>
            </div>

            <div class="form-card" id="event-form">
              <div
                class="npf_wgts"
                data-height="600px"
                data-w="213ccd08fe1a34533657143f9a935239"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row mobile_flex_direction">
          <div class="col-md-6 col-xl-6 mobile_margin" data-aos="fade-right">
            <h3 class="main-heading-1-gradient custom_font">Reason 1</h3>
            <ul class="list-item icon-list-item">
              <p>You will get on the Spot Scholarship Offer</p>
            </ul>
            <h3 class="main-heading-1-gradient custom_font">Reason 2</h3>
            <ul class="list-item icon-list-item">
              <p>Get Spot Offer for Application Fee Waiver</p>
            </ul>

            <h3 class="main-heading-1-gradient custom_font">Reason 3</h3>
            <ul class="list-item icon-list-item">
              <p
                >Top Ranking Universities will be present from:- USA | UK |
                CANADA | AUSTRALIA | NZ | GERMANY | FRANCE | IRELAND |
                SWITZERLAND | UAE</p
              >
            </ul>
          </div>

          <div class="col-md-6 col-lg-6" data-aos="fade-left">
            <section class="overlay_color">
              <div class="hero-section">
                <h2 class="main-heading-1">
                  3 GOOD REASONS WHY YOU SHOULDN'T MISS GLOBAL EDUCATION FAIR
                  2023</h2
                >
              </div>
            </section>
            <!-- <img
              src="@/assets/imgs/fair/1-2.jpg"
              class="img-fluid border-all"
            /> -->
          </div>
        </div>
      </div>
    </section>

    <!---->

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="main-heading-1-gradient text-center">
              Explore the world at Global Education Fair, 2023
            </h2>
            <!-- <p class="main-content-1">
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p> -->
          </div>
          <div
            class="col-md-6 col-xl-6"
            data-aos="fade-right"
            style="padding-top:2rem"
          >
            <p class="intro-para"
              >Take this opportunity to explore the world of higher education!
              Attend the Global Education Fair 2023 sponsored by Aliff Overseas
              - www.aliff.in to learn more about the diverse array of
              educational opportunities available to you.</p
            >
          </div>

          <div
            class="col-md-6 col-lg-6"
            data-aos="fade-left"
            style="padding-top:2rem"
          >
            <p class="intro-para"
              >Speak with representatives from top universities and colleges
              around the world. Ask questions and get your doubts clarified.
              This is your chance to discover the perfect fit for you and your
              dreams!
            </p>

            <p class="intro_para"
              ><b
                >Don't miss out on this amazing opportunity - register today!</b
              ></p
            >

            <!-- <img
              src="@/assets/imgs/fair/1-2.jpg"
              class="img-fluid border-all"
            /> -->
          </div>

          <div class="col-lg-12 mt-4 text-center">
            <a href="#event-form"
              ><button type="submit" class="btn btn-secondary-red">
                Register
              </button></a
            >
          </div>
        </div>
      </div>
    </section>

    <!--Image Gallery-->
    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="main-heading-1-gradient text-center">
              Our past events...
            </h2>
            <!-- <p class="main-content-1">
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p> -->
          </div>
          <div id="app" class="col-12" style="padding-top:2rem">
            <CoolLightBox :items="items" :index="index" @close="index = null">
            </CoolLightBox>

            <div class="images-wrapper">
              <div
                class="image"
                v-for="(image, imageIndex) in items"
                :key="imageIndex"
              >
                <img
                  :src="image"
                  @click="index = imageIndex"
                  class="img-fluid custom_sizing"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--University Promotion-->

    <section class="university-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-6 text-center"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 class="main-heading-1-gradient text-center"
              >Few of our participating universities...</h2
            >
          </div>
          <div class="col-lg-12 mt-3 pt-xl-1">
            <slick
              ref="logoSlider"
              :options="logoSlider"
              class="logo-slider"
              v-if="featured_universities.length > 0"
            >
              <div
                v-for="(university, index) in featured_universities"
                :key="'featured_universities_' + index"
              >
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="university"
                      class="img-fluid"
                      @click="
                        (e) =>
                          $router.push({
                            name: 'UniversityAbout',
                            params: {
                              university_id: university[0].university_id,
                            },
                          })
                      "
                      style="margin:auto"
                    />
                  </div>
                </div>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </section>

    <!--Principal Sponser-->
    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <h2 class="main-heading-1-gradient text-center">
              PRINCIPAL SPONSOR
            </h2>
            <img
              class="main-logo"
              src="@/assets/imgs/main-logo.svg"
              width="120px"
            />
            <!-- <p class="main-content-1">
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p> -->
          </div>
          <div
            class="col-md-12 col-xl-12"
            data-aos="fade-top"
            style="padding-top:2rem"
          >
            <p class="intro-para text-center">
              PRINCIPAL SPONSOR Address: ALIFF OVERSEAS, 203, God’s Gift Tower,
              Next To Lucky Hotel, S.V. Road, Bandra (West), Mumbai – 400050,
              India Contact: +91-9987099890 | Email: info@aliff.in</p
            >
          </div>
          <div class="social-icons d-flex pt-3">
            <a href="https://www.instagram.com/aliffoverseas/" target="blank">
              <img src="@/assets/imgs/svgs/instagram.svg" class="img-fluid" />
            </a>
            <a href="https://www.facebook.com/aliffoverseas/" target="blank">
              <img src="@/assets/imgs/svgs/facebook.svg" class="img-fluid" />
            </a>
            <a href="https://twitter.com/aliffoverseas/" target="blank">
              <img src="@/assets/imgs/svgs/twitter.svg" class="img-fluid" />
            </a>
            <a
              href="https://in.linkedin.com/company/aliffoverseas"
              target="blank"
            >
              <img src="@/assets/imgs/svgs/linkedin.svg" class="img-fluid" />
            </a>
            <a href="https://www.youtube.com/aliffoverseas/" target="blank">
              <img src="@/assets/imgs/svgs/youtube.svg" class="img-fluid" />
            </a>
          </div>
        </div>
      </div>
    </section>

    <!--Social Icons-->

    <!-- <ContactusSection /> -->

    <!-- <section class="study-abroad-fair--footer text-center px-5 py-5">
      <h5>Copyright © 2021 Aliff, inc</h5>
    </section> -->
    <!-- <RecentPostSection
      :recentPostsData="recentPostData['career-page']['data-1']"
    /> -->
  </div>
</template>

<script>
  import homeServices from "@/apiServices/homeServices";
  import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
  import { DASHBOARD_REGISTER_URL } from "@/config";
  import CoolLightBox from "vue-cool-lightbox";
  import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
  import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
  import RecentPostSection from "@/components/partials/RecentPostSection.vue";
  import ContactusSection from "@/components/partials/ContactusSection.vue";

  export default {
    components: {
      CoolLightBox,
      BookFreeCounselling,
      VideoTestimonialSlider,
      TextTestimonialSlider,
      RecentPostSection,
      ContactusSection,
    },
    metaInfo: {
      title:
        "Study Abroad fair | Master / MBA Programs - A post-grad focused education fair",
      htmlAttrs: {
        lang: "en-US",
      },
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content:
            "Your dream of studying abroad awaits you! Let’s kickstart it together, right now. Make us a part of your journey and let’s rock it!",
        },
        { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      ],
    },
    data() {
      return {
        featured_universities: [
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/Minimalist+Modern+Company+Logo+A4+Document+Paper.png",
        ],
        items: [
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/0G6A7510_edited.jpg",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/0G6A7185_edited.jpg",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/2-1068x712.jpeg",

          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/319290690_5653309614724155_3367946546535199566_n_edited+(1).jpg",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/happy-middle-eastern-woman-student-holding-diverse-flags.jpg",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/1-2-1.webp",

          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/12-1.webp",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/285066235_5103556903032765_5612134423240541837_n_edited.jpg",
          "https://aliff-production-1.s3.ap-south-1.amazonaws.com/Fair+Images/285106315_5103556883032767_1836400879228576290_n_edited.jpg",
        ],

        index: null,
        service: [],
        showPlan: false,
        DASHBOARD_REGISTER_URL,
        search_tags: [
          "USA",
          "UK",
          "Canada",
          "NZ",
          "Switzerland",
          "Singapore",
          "France",
          "Germany",
          "Dubai",
        ],
        videoSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: false,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 2.5,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
        pricingSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },

        postSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: true,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
      };
    },
    methods: {
      // PayNow(pp) {
      //   var elms = document.getElementById(pp).getElementsByTagName("a");
      //   elms[0].click();
      // },
      clickShowPlan() {
        this.showPlan = !this.showPlan;
      },
      async getServicePlan() {
        try {
          const response = await homeServices.getServicesAndPlans({
            service_id: 5,
          });
          if (response.data.status) {
            this.service = response.data.data[0];
          }
        } catch (err) {
          console.log("Error in getting getServicePlan ", err);
        }
      },
      addCommas(amt) {
        return amt.toLocaleString("en-IN");
      },
    },
    beforeMount() {
      this.getServicePlan();
    },
  };
</script>

<style scoped>
  .study-abroad-fair .hero-text-img-section {
    /* background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%); */
    /* color: white; */
  }
  .study-abroad-fair .page-intro-line {
    /* color: white; */
  }
  .study-abroad-fair .main-logo {
    /* filter: brightness(0) invert(1); */
  }
  .study-abroad-fair--footer {
    background: rgba(83, 103, 255, 0.05);
  }
  .event-details {
    /* display: flex; */
    justify-content: center;
    margin: 40px 100px;
  }
  .event-details img {
    width: 40px;
  }
  .event-details div {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 5px;
  }
  .form-card {
    /* background: white; */
    background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);

    box-shadow: 0 10px 20px rgb(40 111 219 / 30%);
    border-radius: 10px;
    padding: 41px;
  }
  .fair-hero-img img {
    width: 100% !important;
    /* margin-top: -15%; */
  }
  .fair-logos-section img {
    width: 165px;
    height: 80px;
    object-fit: contain;
  }
  .custom_font {
    font-size: 35px !important;
  }
  .custom_img_design {
    border-radius: 8px;
    object-fit: cover;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    width: 75%;
    margin: 0 auto;
    display: flex;
  }
  .svg_custom_width {
    width: 30px !important;
  }
  .images-wrapper {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .image {
    height: 300px;
    width: 300px;
    display: flex;
    justify-content: center;
    /* background-color: red; */
  }
  /* .image img {
    border-radius: 8px;
  } */
  .social-icons {
    gap: 10px;
  }
  .social-icons img {
    width: 30px;
  }
  .custom_sizing {
    /* aspect-ratio: 3/4; */
    object-fit: cover;
    border-radius: 10px;
  }
  .custom_logo_global {
    width: 40%;
    margin: 0 auto;
  }
  .custom_font_title {
    font-weight: bold;
  }
  @media screen and (max-width: 768px) {
    .custom_img_design {
      width: 90%;
    }
    .event-details {
      margin: 20px;
    }
    .mobile_flex_direction {
      flex-direction: column-reverse;
    }
    .mobile_margin {
      margin-top: 35px;
    }
    .icon-list-item p {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StudyAbroadFairNew.vue